import React from 'react';
import { headerImages } from "../../helpers/images";
const HeaderImage = function ({ name }) { return /*#__PURE__*/ React.createElement("img", { src: headerImages[name], alt: `${name} icon` }); };
export default HeaderImage;
